export default function($) {
  $(document).ready(function(){
    $('.js-date-picker').datepicker({
      dateFormat: 'dd/mm/yy',
    });
  });
}
